import type { PaywallCurrency } from "./Paywall";

export const paywallCouponStatuses = {
  active: "active",
  inactive: "inactive",
} as const;

export const paywallCouponDurations = {
  forever: "forever",
  once: "once",
  repeating: "repeating",
} as const;

export type PaywallCouponDuration = keyof typeof paywallCouponDurations;

export type PaywallCouponStatus = keyof typeof paywallCouponStatuses;

export interface PaywallCoupon {
  active: boolean;
  all_paywalls: boolean;
  amount: number;
  code: string;
  currency: PaywallCurrency;
  currency_id?: number;
  duration: PaywallCouponDuration;
  duration_in_months: number;
  enable_end_date: boolean;
  enable_start_date: boolean;
  ends_at: string;
  id: number;
  is_default: boolean;
  max_charge_amount: number;
  min_charge_amount: number;
  name: string;
  paywall_ids: number[];
  redemptions_count: number;
  starts_at: string;
  status: PaywallCouponStatus;
  symbol: string;
  terms: string;
  type: "PaywallCoupons::Fixed" | "PaywallCoupons::Percent";
}
